import styled, { css } from 'styled-components';
import type { TypographyProps } from '@elfsight/widget-ui';
import { createReadableClass } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { usePlayer } from '../../../player';
import type { ExtendedAudioItem } from '../../../sources';
import { StyledTitle as CommonStyledTitle } from '../Title';
import { Status } from './Status';

interface TitleProps {
  textStyle: TypographyProps['textStyle'];
  wrap?: boolean;
  track?: ExtendedAudioItem;
}

export function Title({ textStyle, wrap, track }: TitleProps) {
  const { playerParts } = useSettings();
  const { currentItem } = usePlayer();
  const { title, hasTitle } = track ?? currentItem ?? {};

  const withStatus = playerParts.includes('status') && !track;

  if (!hasTitle && !withStatus) {
    return null;
  }

  return (
    <TitleContainer _wrap={wrap}>
      {hasTitle && (
        <StyledTitle
          textStyle={textStyle}
          _withStatus={withStatus}
          _wrap={wrap}
        >
          {title}
        </StyledTitle>
      )}

      {withStatus && <Status />}
    </TitleContainer>
  );
}

const StyledTitle = styled(CommonStyledTitle).attrs<{
  _withStatus: boolean;
}>({
  className: createReadableClass({
    component: 'radio-track-info',
    element: 'title'
  })
})`
  display: inline;
  vertical-align: middle;

  ${({ _withStatus }) =>
    _withStatus &&
    css`
      margin-right: 8px;
    `};
`;

const TitleContainer = styled.div.attrs({
  className: createReadableClass({
    component: 'radio-track-info',
    element: 'title-container'
  })
})<{ _wrap?: boolean }>`
  ${({ _wrap }) =>
    !_wrap &&
    css`
      display: flex;
      align-items: center;
    `}
`;
